import i18next from 'i18next';
import React, { Component } from 'react';
import { EVENT } from '../../../common/events/listEvents';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
export default class AlertComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isConfirmAlert: false,
      btnYesText: this.translate('OK'),
      actionYes: this.handleCloseAction,
      btnNoText: this.translate('Cancel'),
      className: 'alert'
    };
  }

  translate(key) {
    return i18next.t(key)
  }

  componentDidMount() {
    window.listenEvent(EVENT.OPEN_ALERT, this.activeAlert);
    window.listenEvent(EVENT.CLOSE_ALERT, this.handleClose);
  }

  componentWillUnmount() {
    window.stopListenEvent(EVENT.OPEN_ALERT, this.activeAlert)
    window.stopListenEvent(EVENT.CLOSE_ALERT, this.handleClose)
  }

  activeAlert = () => {
    let alertComp = window.alertComp;
    if (alertComp != null) {
      if (alertComp.isConfirmAlert) {
        this.setState({
          message: alertComp.message,
          title: alertComp.title,
          isConfirmAlert: alertComp.isConfirmAlert || false,
          actionYes: alertComp.actionYes || null,
          btnYesText: alertComp.btnYesText || this.translate('OK'),
          actionNo: alertComp.actionNo || null,
          btnNoText: alertComp.btnNoText || this.translate('Cancel'),
          className: alertComp.className ? 'alert ' + alertComp.className : 'alert',
          compClass: 'modal_' + alertComp.className,
          isShowCloseIcon: alertComp.isShowCloseIcon ? alertComp.isShowCloseIcon : false,
          isCloseIconAction: alertComp.isCloseIconAction || null,
        });
      } else {
        this.setState({
          message: alertComp.message,
          title: alertComp.title,
          actionNo: alertComp.actionYes || null,
          btnYesText: alertComp.btnYesText || this.translate('OK'),
          btnNoText: alertComp.btnNoText || this.translate('Cancel'),
          className: alertComp.className ? 'alert ' + alertComp.className : 'alert',
          compClass: 'modal_' + alertComp.className,
          isShowCloseIcon: alertComp.isShowCloseIcon ? alertComp.isShowCloseIcon : false
        });
      }

      window.alertComp = {};
    }
  }

  handleCloseAction = () => {
    const { isCloseIconAction } = this.state
    if (isCloseIconAction) {
      this.handleActionNo();
    } else {
      window.fireEvent(EVENT.CLOSE_ALERT);
    }
  }

  handleClose = () => {
    this.setState({
      message: "",
      title: "",
      isConfirmAlert: false,
      actionYes: null,
      btnYesText: this.translate('OK'),
      btnNoText: this.translate('Cancel'),
      compClass: ''
    });
  }

  handleActionNo = () => {
    const { actionNo } = this.state
    const isMigrated = localStorage.getItem('urlMigration') || null;
    if(isMigrated) {
      localStorage.removeItem('urlMigration');
      window.location.href = isMigrated;
    }
    if (actionNo) {
      actionNo()
    }
    this.handleClose()
  }

  handleActionYes = (event) => {
    event.preventDefault();
    const { actionYes } = this.state

    if (actionYes) {
      actionYes()
    }
  }

  handleOnHide = () => {
    const { actionNo } = this.state

    if (actionNo) {
      actionNo()
    }
  }

  renderFooter = () => {
    const { btnYesText, btnNoText, isConfirmAlert } = this.state

    if (isConfirmAlert) {
      return (
        <div className="buttons">
          <Button variant="primary" onClick={this.handleActionYes} >
            {btnYesText}
          </Button>
          <Button variant="cancel" className="ml-2" onClick={this.handleActionNo}>
            {btnNoText}
          </Button>
        </div>
      )
    }

    return (
      <div className="buttons">
        <Button variant="primary" onClick={this.handleActionNo}>{btnYesText}</Button>
      </div>
    )
  }

  renderTitle = () => {
    const {title, isShowCloseIcon} = this.state
    if (!title && !isShowCloseIcon) {
      return null
    } 

    return (
      <Modal.Header closeButton onClick={this.handleCloseAction}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )
  }

  render() {
    const {message, className, compClass} = this.state
    let isRender = message != ''

    return (
      <div className="alert_modal_container">
        <Modal className={compClass} backdrop='static' backdropClassName={className} dialogClassName={className} show={isRender} onHide={this.handleOnHide}>
          {this.renderTitle()}
          <Modal.Body><div dangerouslySetInnerHTML={{__html:message}}></div></Modal.Body>
          <Modal.Footer>
            {this.renderFooter()}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/AlertComponent/index.js